import { render, staticRenderFns } from "./OptionsSwitch.vue?vue&type=template&id=ca9a890c&scoped=true&"
import script from "./OptionsSwitch.vue?vue&type=script&lang=js&"
export * from "./OptionsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./OptionsSwitch.vue?vue&type=style&index=0&id=ca9a890c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9a890c",
  null
  
)

export default component.exports